import React, { useEffect, createElement } from 'react';
import { HeroSection } from '../components/landing/HeroSection';
import { ProblemSection } from '../components/landing/ProblemSection';
import { FailedSolutions } from '../components/landing/FailedSolutions';
import { MechanismSection } from '../components/landing/MechanismSection';
import { WhatYouGet } from '../components/landing/WhatYouGet';
import { AudienceSection } from '../components/landing/AudienceSection';
import { HowItWorks } from '../components/landing/HowItWorks';
import { ProofSection } from '../components/landing/ProofSection';
import { FAQSection } from '../components/landing/FAQSection';
import { OfferBlock } from '../components/landing/OfferBlock';
export function BloatProtocolPage() {
  useEffect(() => {
    // Load Meta Pixel
    if (!(window as any).fbq) {
      const n = ((window as any).fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      }) as any;
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
    ;
    (window as any).fbq('init', '666521186552257');
    (window as any).fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen bg-cream font-sans selection:bg-sage/20 selection:text-charcoal overflow-x-hidden" data-id="element-122">
      <HeroSection data-id="element-123" />
      <ProblemSection data-id="element-124" />
      <FailedSolutions data-id="element-125" />
      <MechanismSection data-id="element-126" />
      <WhatYouGet data-id="element-127" />
      <AudienceSection data-id="element-128" />
      <HowItWorks data-id="element-129" />
      <ProofSection data-id="element-130" />
      <FAQSection data-id="element-131" />
      <OfferBlock data-id="element-132" />
    </main>;
}